interface RoomDetailsChanges {
    readonly saveName?: () => Promise<void>;
    readonly saveAvatar?: () => Promise<void>;
}

type RoomDetailsSaveResult =
    | {readonly kind: 'saved'}
    | {readonly kind: 'failed'; readonly nameSaved: boolean; readonly error: unknown};

export async function saveRoomDetails(changes: RoomDetailsChanges): Promise<RoomDetailsSaveResult> {
    let nameSaved = false;
    try {
        if (changes.saveName) {
            await changes.saveName();
            nameSaved = true;
        }
        await changes.saveAvatar?.();
        return {kind: 'saved'};
    } catch (error) {
        return {kind: 'failed', nameSaved, error};
    }
}
